import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureAmplify, TenantNotFoundError } from './amplify-config';
import './index.css';

// AWS Amplify UI Theme
import '@aws-amplify/ui-react/styles.css';

(async () => {
    try {
        await configureAmplify();
    } catch (err: unknown) {
        const root = document.getElementById('root');
        if (root) {
            while (root.firstChild) {
                root.removeChild(root.firstChild);
            }
        }

        if (err instanceof TenantNotFoundError) {
            const tenantNotFoundContainer = document.getElementById('pre-react-tenant-not-found');
            if (tenantNotFoundContainer) {
                tenantNotFoundContainer.style.display = 'flex';
            }
            return;
        }

        const errorContainer = document.getElementById('pre-react-error');
        const errorMessage = document.getElementById('pre-react-error-message');
        if (errorContainer) {
            errorContainer.style.display = 'flex';
        }
        if (errorMessage) {
            errorMessage.textContent = err instanceof Error
                ? err.message
                : 'An unexpected error occurred';
        }
        return;
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
})();
